import React from 'react';
import { motion } from 'framer-motion';
import { useMotionPreference } from '../../../hooks/useMotionPreference';
const ROUTE = 'M 36 146 C 80 146, 96 112, 138 106 S 206 92, 236 70 S 300 44, 344 40';
const DRAW = {
  duration: 0.9,
  delay: 0.25,
  ease: [0.65, 0, 0.35, 1] as const
};

/** A small map: the route draws itself from home to the destination. Labels are HTML so they stay ≥ 22 px. */
export function RouteMap({
  destination
}: {
  destination: string;
}) {
  const reduce = useMotionPreference();
  return <div className="relative aspect-[380/176] w-full overflow-hidden rounded-2xl bg-night-950/50" data-id="element-1570" data-mp="2xavflphvra3q">
      <svg viewBox="0 0 380 176" className="absolute inset-0 h-full w-full" role="img" aria-label={`Route van thuis naar ${destination}`} data-id="element-1571" data-mp="2sdwmna9yd974">
        <path d="M -10 30 C 80 60, 160 20, 230 140 S 330 170, 400 120" stroke="#8FB8D8" strokeOpacity="0.14" strokeWidth="12" fill="none" data-id="element-1572" data-mp="2nfv8n3rdw02i" />
        <g stroke="rgba(255,255,255,0.08)" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-1573" data-mp="llvywmtwtqrx">
          <path d="M 0 120 L 380 96" data-id="element-1574" data-mp="30ze75z1eh9wd" />
          <path d="M 0 62 L 380 30" data-id="element-1575" data-mp="30yciusvdiqwp" />
          <path d="M 70 176 L 120 0" data-id="element-1576" data-mp="351iwilktfkd7" />
          <path d="M 200 176 L 250 0" data-id="element-1577" data-mp="352k8cs9noavz" />
          <path d="M 300 176 L 330 0" data-id="element-1578" data-mp="34zei39paj2yo" />
          <path d="M 0 162 C 120 152, 260 152, 380 140" data-id="element-1579" data-mp="2r29fjjoscm86" />
        </g>
        <motion.path d={ROUTE} fill="none" strokeWidth="4.5" strokeLinecap="round" style={{
        stroke: 'rgb(var(--accent))'
      }} initial={{
        pathLength: reduce ? 1 : 0
      }} animate={{
        pathLength: 1
      }} transition={reduce ? {
        duration: 0
      } : DRAW} data-id="element-1580" data-mp="2r42r9de99wn1" />
        <circle cx="36" cy="146" r="8" fill="#EEF2F6" data-id="element-1581" data-mp="3a13w8y7t7wqz" />
        <motion.g initial={{
        opacity: reduce ? 1 : 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.2,
        delay: reduce ? 0 : 1.1
      }} data-id="element-1582" data-mp="39yhpv1wnnnac">
          <circle cx="344" cy="40" r="16" fill="none" strokeWidth="2" style={{
          stroke: 'rgb(var(--accent) / 0.45)'
        }} data-id="element-1583" data-mp="6j3n3fqiplbs" />
          <circle cx="344" cy="40" r="8" style={{
          fill: 'rgb(var(--accent))'
        }} data-id="element-1584" data-mp="bcolv9zxqjc1" />
        </motion.g>
      </svg>
      <span className="absolute bottom-[4%] left-[15%] text-[22px] text-ink-soft" data-id="element-1585" data-mp="l4808f8lzlve">Thuis</span>
      <motion.span className="absolute right-[14%] top-[6%] text-[22px] font-medium text-ink" initial={{
      opacity: reduce ? 1 : 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.2,
      delay: reduce ? 0 : 1.1
    }} data-id="element-1586" data-mp="g5eigamah8pf">
        {destination}
      </motion.span>
    </div>;
}